/*!

=========================================================
*  Prognostic AssetSuite - v1.0
=========================================================
* Product Page: https://prognostic.io
* Copyright 2020
* Licensed under TBA


Reference to components used from:
=========================================================
*  Dashboard React - v1.9.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// @material-ui/icons
import { Error, InsertChart, Map, Reorder } from "@material-ui/icons";
import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
import Language from "@material-ui/icons/Language";

// core components/views for SaaS layout
import AMDashboardPage from "./domain/AssetMaintain/Dashboard";
import AIDashboardPage from "./domain/AssetInvest/Dashboard";
import UserProfile from "./domain/User/Profile";
import ReportsList from "./domain/Reports/TableList";
import SuppliersList from "./domain/Suppliers/TableList";
import Maps from "./domain/Views/Maps/Maps";
import WorkOrder from "./domain/Workorders/WorkOrder";
import Issue from "./domain/Issues/Issue";
import WorkOrderDetail from "./domain/Workorders/WorkOrderDetail";
import IssueLogDetail from "./domain/Issues/IssueLogDetail";
import APDashboard from "./domain/AssetPredict/Dashboard";
import OEESummary from "./domain/AssetPredict/Operations";
import Monitoring from "./domain/AssetPredict/Monitoring";

// core components/views for RTL layout
//import RTLPage from "./domain/Views/RTLPage/RTLPage";

export const suiteAppRoutes = [
  {
    suiteApp: "asset-maintain",
    routes: [
      {
        path: "/dashboard",
        name: "Dashboard",
        header: "Asset Maintain Dashboard",
        icon: Dashboard,
        component: AMDashboardPage,
        layout: "/saas",
      },
      {
        path: "/work-order",
        name: "Work Orders",
        header: "Work Orders",
        icon: Reorder,
        component: WorkOrder,
        layout: "/saas",
      },
      {
        path: "/map",
        name: "Asset Locations",
        header: "Asset Locations",
        icon: Map,
        component: Maps,
        layout: "/saas",
      },
      {
        path: "/issue",
        name: "Issues",
        header: "Issue log Page",
        icon: Error,
        component: Issue,
        layout: "/saas",
      },
      {
        path: "/issue-log-detail",
        name: "Issues Detail",
        header: "Issue Detail Page",
        icon: Error,
        component: IssueLogDetail,
        layout: "/saas",
        navbar: false,
      },
      {
        path: "/work-order-detail",
        name: "Work Order Detail",
        header: "Work Order Details",
        icon: Reorder,
        component: WorkOrderDetail,
        layout: "/saas",
        navbar: false,
      },
    ],
  },
  {
    suiteApp: "asset-predict",
    routes: [
      {
        path: "/dashboard",
        name: "Dashboard",
        header: "Asset Predict Dashboard",
        icon: Dashboard,
        component: APDashboard,
        layout: "/saas",
      },
      {
        path: "/monitoring",
        name: "Monitoring",
        header: "Monitoring",
        icon: Error,
        component: Monitoring,
        layout: "/saas",
      },
      {
        path: "/oee",
        name: "OEE Summary",
        header: "OEE",
        icon: Error,
        component: OEESummary,
        layout: "/saas",
      },
    ],
  },
  {
    suiteApp: "asset-invest",
    routes: [
      {
        path: "/dashboard",
        name: "Dashboard",
        header: "Asset Invest Dashboard",
        icon: Dashboard,
        component: AIDashboardPage,
        layout: "/saas",
      },
      {
        path: "/portfolio",
        name: "Portfolio",
        header: "Asset Portfolio",
        icon: Error,
        component: AIDashboardPage,
        layout: "/saas",
      },
      {
        path: "/aireports",
        name: "Cost Summary",
        header: "Cost Summary",
        icon: Error,
        component: AIDashboardPage,
        layout: "/saas",
      },
      {
        path: "/airisk",
        name: "Risk Projection",
        header: "cost",
        icon: Error,
        component: OEESummary,
        layout: "/saas",
      },
    ],
  },
  {
    suiteApp: "platform",
    appliesTo: ["asset-maintain", "asset-predict"],
    routes: [
      {
        path: "/reports",
        name: "Reports",
        header: "Reports Dashboard",
        rtlName: "الرموز",
        icon: InsertChart,
        component: ReportsList,
        layout: "/saas",
      },
      {
        path: "/suppliers",
        name: "Vendors",
        header: "Vendors List",
        rtlName: "پشتیبانی از راست به چپ",
        icon: Language,
        component: SuppliersList,
        layout: "/saas",
      },
      {
        path: "/user",
        name: "User Profile",
        header: "User Profile",
        rtlName: "ملف تعريفي للمستخدم",
        icon: Person,
        component: UserProfile,
        layout: "/saas",
      },
    ],
  },
];

export const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    header: "Asset Maintain Dashboard",
    icon: Dashboard,
    component: AMDashboardPage,
    layout: "/saas",
  },
  {
    path: "/map",
    name: "Asset Location",
    header: "Asset Location",
    icon: Map,
    component: Maps,
    layout: "/saas",
  },
  {
    path: "/work-order-detail",
    name: "Work Order Detail",
    header: "Work Order Detail Page",
    icon: Reorder,
    component: WorkOrderDetail,
    layout: "/saas",
  },
  {
    path: "/issue",
    name: "Issues",
    header: "Issue log Page",
    icon: Error,
    component: Issue,
    layout: "/saas",
  },
  {
    path: "/issue-log-detail",
    name: "Issues Detail",
    header: "Issue Detail Page",
    icon: Error,
    component: IssueLogDetail,
    layout: "/saas",
  },
  {
    path: "/predict-maintain-dashboard",
    name: "Predict Maintain Dashboard",
    header: "Predict Maintain Dashboard",
    icon: Error,
    component: Monitoring,
    layout: "/saas",
  },
  {
    path: "/predict-maintain-monitoring",
    name: "Predict Maintain Monitoring",
    header: "Predict Maintain Monitoring",
    icon: Error,
    component: Monitoring,
    layout: "/saas",
  },
  {
    path: "/plant-operation-dashboard",
    name: "Plant Operation Dashboard",
    header: "Plant Operation Dashboard",
    icon: Error,
    component: OEESummary,
    layout: "/saas",
  },
  {
    path: "/reports",
    name: "Reports",
    header: "Reports Dashboard",
    rtlName: "الرموز",
    icon: InsertChart,
    component: ReportsList,
    layout: "/saas",
  },
  {
    path: "/suppliers",
    name: "Vendors",
    header: "Vendors List",
    rtlName: "پشتیبانی از راست به چپ",
    icon: Language,
    component: SuppliersList,
    layout: "/saas",
  },
  {
    path: "/user",
    name: "User Profile",
    header: "User Profile",
    rtlName: "ملف تعريفي للمستخدم",
    icon: Person,
    component: UserProfile,
    layout: "/saas",
  },
];
